export default {
  integrations: [],
  integration: {},
  providers: [],
  availableFields: [],
  syncLogs: []
}
